import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-standard-development-application2',
  templateUrl: './standard-development-application2.component.html',
  styleUrls: ['./standard-development-application2.component.scss']
})
export class StandardDevelopmentApplication2Component implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

}
